import { Button } from "@mui/material";

export default function SpacedButton({ children, sx, ...props }) {
  return (
    <Button {...props} sx={{ ...sx, letterSpacing: "1.25px" }}>
      {children}
    </Button>
  );
}
